import {FieldMetaState} from 'react-final-form'

export const defaultShowError = (meta: FieldMetaState<unknown>) => {
  const {active, submitError, modifiedSinceLastSubmit} = meta
  return !active && !modifiedSinceLastSubmit && submitError ? submitError : undefined
}
